import React from 'react'
import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'
import GallerySwiper from './gallery-swiper'
import {parseAndSanitizeJSON} from '../../../utils/utils'
import YoutubeIframe from '../../youtube-video'

const ProductDetailGallery = ({
    heroImageGroup,
    loadingStrategy = 'lazy',
    openModal,
    videoUrl,
    selectedIndex,
    handleGalleryNavigation,
    swiperRef,
    styles,
    variant,
    setIsModalGallerySwiper,
    isModalOpen,
    subModelIdentifier,
}) => {
    const video = parseAndSanitizeJSON(videoUrl)?.[0]

    return !isModalOpen && selectedIndex === video?.code ? (
        <Flex {...styles.inGridVideoHero} data-testid="image-gallery-video">
            <YoutubeIframe title={video.title} videoSrc={video.videolink} />
        </Flex>
    ) : (
        <GallerySwiper
            heroImageGroup={heroImageGroup}
            loadingStrategy={loadingStrategy}
            openModal={openModal}
            selectedIndex={selectedIndex}
            styles={styles}
            swiperRef={swiperRef}
            variant={variant}
            handleGalleryNavigation={handleGalleryNavigation}
            setIsModalGallerySwiper={setIsModalGallerySwiper}
            subModelIdentifier={subModelIdentifier}
        />
    )
}

ProductDetailGallery.propTypes = {
    heroImageGroup: PropTypes.object,
    loadingStrategy: PropTypes.string,
    openModal: PropTypes.func,
    videoUrl: PropTypes.string,
    selectedIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    swiperRef: PropTypes.object,
    styles: PropTypes.object,
    variant: PropTypes.string,
    handleGalleryNavigation: PropTypes.func,
    setIsModalGallerySwiper: PropTypes.func,
    isModalOpen: PropTypes.bool,
    subModelIdentifier: PropTypes.string,
}

export default ProductDetailGallery
